import { use } from 'react'
import { RosePlanCard, PlannedMaterialEntry } from '~/components/subscription/rose-plan-card'
import image from './images/1.jpg'

type Props = {
  plannedMaterialEntries: Promise<PlannedMaterialEntry[]>
}

export const FeaturesSection: React.FC<Props> = ({ plannedMaterialEntries }) => {
  const entries = use(plannedMaterialEntries)

  return (
    <section className="bg-bg pt-14 pb-6 px-6">
      <div className="max-w-md mx-auto flex flex-col gap-6 items-center">
        <div className="flex flex-col gap-4 items-center">
          <h2 className="text-[24px] font-bold text-black text-center leading-[1.4]">
            フローリストが
            <br />
            惚れ込んだバラだけ
          </h2>
          <p className="text-[14px] leading-[1.6] text-black">
            日々たくさんの花を見ているフローリストにも、忘れられないバラがあります。この定期便で届くのは、まさにハートを撃ち抜かれた！と感じるような色や形のもの。品種だけでなく「誰が育てたのか」まで見て選びます。
          </p>
        </div>
        <img src={image} alt="" className="w-full aspect-4/5 object-cover rounded-2xl" />
        {entries.length > 0 && <RosePlanCard entries={entries} />}
      </div>
    </section>
  )
}
